module.exports = __webpack_public_path__ + "static/media/52.e9c9bb9d.jpg";